import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            全站索引
          </h2>
          <p className="text-sm text-foreground-500 mt-1">按分类快速找到你想看的剧</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {indexData.map((item, index) => (
            <a
              key={index}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                const target = document.querySelector('#cards');
                if (target) target.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex items-center justify-between bg-background-50 rounded-xl border border-background-200 px-5 py-4 hover:border-primary-200 hover:bg-background-50 transition-colors cursor-pointer"
            >
              <div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{item.description}</p>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.count}</span>
                <i className="ri-arrow-right-s-line text-foreground-300 text-lg"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}